export default __webpack_public_path__ + "static/media/SF_Fedora.dfefb480.ttf";